export default function (cell, formatterParams) {
  const { separator = '<br/>' } = formatterParams;

  const div = document.createElement('div');

  div.innerHTML = (cell.getValue() || []).filter((val) => {
    if (!val) {
      return false;
    }

    if (Array.isArray(val)) {
      return val.length > 0;
    }

    return true;
  }).join(separator);

  return div;
}
